import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_ENDPOINTS, { getImageUrl } from '../../config/api';
import './GalleryImagePicker.css';

const GalleryImagePicker = ({ value, onChange, emptyHint }) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(`${API_ENDPOINTS.ADMIN_GALLERY}?type=all_photos`);
        if (!cancelled) {
          if (res.data.success) {
            setPhotos(res.data.photos || []);
          } else {
            setError('Could not load gallery photos.');
          }
        }
      } catch {
        if (!cancelled) setError('Could not load gallery photos.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <p className="gallery-picker-status">Loading gallery…</p>;
  }

  if (error) {
    return <p className="gallery-picker-status gallery-picker-error">{error}</p>;
  }

  if (photos.length === 0) {
    return (
      <p className="gallery-picker-status">
        {emptyHint || 'No photos in the gallery yet. Upload photos under Gallery Management first.'}
      </p>
    );
  }

  return (
    <div className="gallery-picker">
      {value && (
        <div className="gallery-picker-selected">
          <img src={getImageUrl(value)} alt="Selected" />
          <button type="button" className="gallery-picker-clear" onClick={() => onChange('')}>
            Clear selection
          </button>
        </div>
      )}
      <div className="gallery-picker-grid">
        {photos.map((photo) => {
          const selected = value === photo.image_url;
          return (
            <button
              key={photo.id}
              type="button"
              className={`gallery-picker-item${selected ? ' selected' : ''}`}
              onClick={() => onChange(photo.image_url)}
              title={photo.caption || photo.album_name || 'Gallery photo'}
            >
              <img src={getImageUrl(photo.image_url)} alt={photo.caption || 'Gallery'} />
              {photo.album_name && <span className="gallery-picker-album">{photo.album_name}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GalleryImagePicker;
